import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  list: {
    height: '53vh',
    overflow: 'auto'
  },
  listItem: {
    cursor: 'pointer'
  },
  listItemHeader: {
    borderRadius: 10,
    // backgroundColor: theme.palette.grey[200],
    marginTop: 5,
    padding: 5,
    marginLeft: 5
  },
  rowsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr'
  },
  rowContainer: {
    padding: '5px 10px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 10,
    backgroundColor: theme.palette.grey[100],
    marginTop: 5,
    marginLeft: 30
  },
  header: {
    backgroundColor: theme.palette.grey[300],
    height: 50,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    marginTop: 8
  },
  body: {
    // marginTop: 8
  },
  providerRow: {
    backgroundColor: theme.palette.grey[100],
    height: 46,
    display: 'flex',
    flexDirection: 'row',
    // marginTop: 8,
    alignItems: 'center',
    position: 'relative',
    borderBottom: `1px solid ${theme.palette.grey[300]}`
  },
  channelName: {
    position: 'absolute',
    marginLeft: 56
  },
  arrowIconContainer: {
    position: 'absolute',
    right: 0
  },
  userCheckbox: {
    marginLeft: 8
  },
  emailContainer: {
    position: 'absolute',
    marginLeft: 310
  },
  viewAccessContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'absolute',
    right: 20,
    cursor: 'pointer'
  },
  viewAccess: {
    color: theme.palette.info.main,
    textDecoration: 'underline'
  },
  arrowRightIcon: {
    marginLeft: 10,
    color: theme.palette.info.main,
    fontSize: 14
  }
}))

export default useStyles
